{
  "Can i translate this ?": "Puis-je traduire cela ?",
  "Accounts": "Comptes connectés",
  "Site settings": "Paramètres du site",
  "Language": "Langue",
  "Enable Marmaid": "Activer la sirène",
  "Enable Blur": "Activer le flou",
  "Enable Animations": "Activer les animations",
  "Personal information": "Informations personnelles",
  "NO": "Non",
  "YES": "OUI",
  "General": "Général",
  "Profile": "Le profil",
  "Notifications": "Avis",
  "Identity": "Identité",
  "Tokens": "Jetons",
  "Instances": "Instances",
  "Domains": "Domaines",
  "Sessions": "Séances",
  "My Sessions": "Mes séances",
  "No projects": "Aucun projet",
  "Create project": "Créer un projet",
  "Projects": "Projets",
  "Project name": "Nom du projet",
  "Project description": "Description du projet",
  "Select team": "Choisis une équipe",
  "Set unique description for project": "Définir une description unique pour le projet",
  "Please fill out this field.": "Veuillez remplir ce champ.",
  "Create": "Créer",
  "OwnedBy": "Propriété de",
  "Open": "Ouvrir",
  "Settings": "Réglages",
  "Apps": "applications",
  "Logout": "Se déconnecter",
  "Admin": "Administrateur",
  "Iot": "Pas",
  "Name": "Nom",
  "Email": "E-mail",
  "You have being mentioned inside": "Vous avez été mentionné à l'intérieur",
  "from project": "du projet",
  "by": "par",
  "You have being invited as member inside project": "Vous avez été invité en tant que membre au sein du projet",
  "to build awesome things": "pour construire des choses géniales"
}